<template>
    <div class="w-full flex flex-col justify-between items-center">
        <div class="flex flex-col w-full lg:w-1/2">
             <Form title="Main Screen Advert"
                submitText="Update"
                @submit="saveAdvert()">    
                <div class="mn3-content-alt flex flex-col w-full mb-5 pb-3">
                    <span class="text-xs opacit-60 px-5 pt-1 mn3-content-alt">Current Advert:</span>
                        <div class="text-center mb-0 px-5 pb-1 mn3-content-alt">
                            <div :class="`${currentAdUrl != '' ? 'cursor-pointer' : ''} w-full flex flex-row items-center justify-center text-center md:max-w-screen-sm mx-auto md:rounded overflow-hidden`">
                                <img v-if="$store.state.theme.summaryImageUrl" 
                                    :key="currentBanner"
                                    :src="$store.state.theme.summaryImageUrl" 
                                    :title="currentAdText"
                                    @click="advertClicked" />
                            </div>
                        </div>
                        <Button v-if="$store.state.theme.summaryImageUrl" type="cancel" class="mx-5" label="Delete Banner Image" icon="trash" @click="deleteBanner()" />
                    </div>
                                
                <Notice v-if="this.$route.query.delete == '1' && !hideNotice" :showClose="true" @close="hideNotice = true" title="Deleted" notice="Banner image has been deleted" level="alert" />
                <Notice v-if="this.$route.query.save == '1'  && !hideNotice" :showClose="true" @close="hideNotice = true" title="Success" notice="Banner image has been updated" level="news" />
                <Notice v-if="uploadError != ''" :showClose="true" @close="uploadError = ''" title="Error" :notice="uploadError" level="alert" />
                <Notice v-if="uploadNotice != ''" :showClose="true" @close="uploadNotice = ''" title="Success" :notice="uploadNotice" level="news" icon="arrow-up-tray" />

                <div class="px-3 flex flex-col mt-1">
                    <span class="text-xs opacity-80">Banner Image</span>
                    <input type="file" ref="fileInput" class="pb-5" @change="fileSelected" />
                </div>

                <Field  type="text"
                    label="Link URL"
                    :formValue="fv.adUrl"
                     />
                <Field  type="text"
                    label="Hover Text"
                    :formValue="fv.adText"
                     />
             </Form>
             <Form title="Member Notice Message"
                submitText="Update"
                @submit="saveAlert()">
                <Field type="select"
                    label="Notice Level"
                    @change="checkShowOptions"
                    :formValue="fv.level"
                    :options="[
                        { value: '', label: 'No Notice' },
                        { value: 'news', label: 'News - Green' },
                        { value: 'notice', label: 'Notice - Yellow' },
                        { value: 'alert', label: 'Alert - Red' }
                    ]" />
                <Field v-if="showAlertOptions" type="text"
                    label="Notice Title"
                    :formValue="fv.title"
                     />
                <Field v-if="showAlertOptions" type="textarea"
                    label="Notice Text"
                    :formValue="fv.alert"
                     />
                <Field v-if="showAlertOptions" type="text"
                    label="Url When Clicked"
                    :formValue="fv.url"
                     />
            </Form>
        </div>              
	</div>
</template>

<script>
	import Button from "@/components/Button.vue";
	import Form from "@/components/Form.vue";
	import Field from "@/components/Field.vue";
	import Notice from "@/components/Notice.vue";
    import { ref } from 'vue'
    import { useRouter } from "vue-router"

	export default {
		components:{
			Button,
            Form,
			Field,
            Notice
		},
		data(){
			return {
			};
		},
        methods: {
            checkShowOptions(evt){
                if(evt.target.value == ''){
                    this.showAlertOptions = false
                }else{
                    this.showAlertOptions = true
                }
            },async deleteBanner(){
                 // Update image
                let data = {
                    data: {
                        attributes: {
                                summaryImage: null,
                        }
                    }
                }                
                let resp1 = await this.$fapi.patch("theme", data)
                this.currentBanner++;
                this.$router.push('/admin/settings/?delete=1');
                await new Promise(resolve => setTimeout(resolve, 1));  
                location.reload()
                  
            },
            fileSelected(evt){
                let selectedFiles = Array.from(evt.target.files);
                this.uploadBannner = selectedFiles;        
            },
            async saveAdvert(){                   
                this.uploadNotice = '';
                this.hideNotice = true;

                // Update image
                var formData = new FormData();
                if(this.uploadBannner.length > 0){
                    formData.append('files[]', this.uploadBannner[0]);                    
                    this.$fapi.put("theme/summary_image", formData, {
                        headers: {
                        'Content-Type': 'multipart/form-data'
                        }
                    }).then(async(response) =>{
                        this.$refs.fileInput.value = '';
                        this.currentBanner++;
                        await this.saveAdvertText(false);
                        
                        this.$router.push('/admin/settings/?save=1');
                        await new Promise(resolve => setTimeout(resolve, 1));  
                        location.reload();
                    }).catch((error) => {
                        console.log('error: ', error);                
                        this.uploadError = error.response.data.errors[0].detail;    
                    });
                }else                
                    this.saveAdvertText(true);
                
            },
            async saveAdvertText(showNotice){                

                //Update url and text
                if(this.currentAdText == this.fv.adText.value &&
                    this.currentAdUrl == this.fv.adUrl.value){
                    return;
                    }

                let data = {
                    data: {
                        attributes: {
                                summaryImageLinkUrl: this.fv.adUrl.value,
                                summaryImageAltText: this.fv.adText.value
                        }
                    }
                }                
                let resp1 = await this.$fapi.patch("theme", data)
                this.currentAdText = this.fv.adText.value
                this.currentAdUrl = this.fv.adUrl.value

                if(showNotice)
                    this.uploadNotice = this.uploadNotice != '' ? this.uploadNotice + ', Fields updated' : 'Fields updated';

            },
            async saveAlert(){   
                
                //If 'no alert' selected, clear out values                
                if(this.fv.level.value == ''){
                    this.fv.title.value = '';
                    this.fv.url.value = '';
                    this.fv.alert.value = '';
                }

                let data = {
                    data: {
                        attributes: {
                            alert: {
                                title: this.fv.title.value,
                                url: this.fv.url.value,
                                level: this.fv.level.value,
                                alert: this.fv.alert.value,
                            }
                        }
                    }
                }

                //Update in store
                this.$store.state.fi.alert = data.data.attributes.alert;

                await this.$fapi.patch("", data)
            }
            
        },
        created(){
            document.title = 'Notices and Adverts'
        },
		mounted(){
            //Check for setting form values
            if(this.$store.state.fi.alert){
                this.fv['alert'].value = this.$store.state.fi.alert.alert
                this.fv['level'].value = this.$store.state.fi.alert.level
                this.fv['title'].value = this.$store.state.fi.alert.title
                this.fv['url'].value = this.$store.state.fi.alert.url

                if(this.$store.state.fi.alert.level == '')
                    this.showAlertOptions = false
            }
            
            this.fv['adText'].value = this.$store.state.theme.summaryImageAltText;
            this.fv['adUrl'].value = this.$store.state.theme.summaryImageLinkUrl;
            
            this.currentAdText = this.$store.state.theme.summaryImageAltText;
            this.currentAdUrl = this.$store.state.theme.summaryImageLinkUrl;
		}, 
        setup(){
            
            const showAlertOptions = ref(true)
            const uploadError = ref('')
            const uploadNotice = ref('')
            const uploadBannner = ref([]);
            const currentAdUrl = ref('')
            const currentAdText = ref('')
            const currentBanner = ref(0);
            const hideNotice = ref(false);

			/* Form field values */
			let fv = {}
            fv['alert'] = ref('')
            fv['level'] = ref('')
            fv['title'] = ref('')
            fv['url'] = ref('')
            
            fv['adUrl'] = ref('')
            fv['adText'] = ref('')
            

            return { 
                currentAdText,
                currentAdUrl,
                currentBanner,
				fv,
                hideNotice,
                showAlertOptions,
                uploadBannner,
                uploadError,
                uploadNotice
            }

        }
	}
	
</script>
